import React, { useEffect, useState } from 'react'
import Layout from '../components/layout/Layout'
import Seo from '../components/Seo'
import { Link, useLocation } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'

const Contact: React.FC = () => {
  const location = useLocation()
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [sent, setSent] = useState(false)

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    setSent(params.get('sent') === '1')
  }, [location.search])

  const nextUrl = (typeof window !== 'undefined' ? window.location.origin : 'https://2homes.app') + '/contact?sent=1'
  return (
    <Layout>
      <Seo title="Contact — 2homes.app" canonical="https://2homes.app/contact" robots="index,follow" />
      <div className="max-w-4xl mx-auto px-4 py-10">
        <div className="mb-4">
          <Link to="/" className="inline-flex items-center text-slate-700 hover:text-slate-900">
            <ArrowLeft className="h-4 w-4 mr-2" /> Back to home
          </Link>
        </div>
        <div className="card-glass p-6 sm:p-8">
          <h1 className="text-2xl sm:text-3xl font-bold mb-2">Contact</h1>
          <p className="text-sm text-slate-600 mb-6">Write to us or use the form below.</p>
          <div className="text-sm text-slate-700 mb-6">
            <div><span className="font-medium">E‑mail:</span> <a href="mailto:contact@2homes.app" className="text-blue-600 hover:underline">contact@2homes.app</a></div>
          </div>

          {sent ? (
            <div className="text-sm text-green-700 bg-green-50 border border-green-200 rounded-md p-4">
              Thank you! Your message has been sent. We will reply as soon as possible.
            </div>
          ) : (
            <form 
              action="https://formsubmit.co/contact@2homes.app" 
              method="POST" 
              className="space-y-4"
              onSubmit={() => { if (!isSubmitting) setIsSubmitting(true) }}
            >
              <input type="hidden" name="_template" value="table" />
              <input type="hidden" name="_subject" value="New message from 2homes.app contact form" />
              <input type="hidden" name="_captcha" value="false" />
              <input type="hidden" name="_next" value={nextUrl} />

              <div>
                <label htmlFor="name" className="block text-sm font-medium text-slate-700 mb-1">Name</label>
                <input id="name" name="name" type="text" required readOnly={isSubmitting} className="w-full rounded-md border border-slate-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white/90" placeholder="John" />
              </div>

              <div>
                <label htmlFor="email" className="block text-sm font-medium text-slate-700 mb-1">E‑mail</label>
                <input id="email" name="email" type="email" required readOnly={isSubmitting} className="w-full rounded-md border border-slate-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white/90" placeholder="john.doe@example.com" />
              </div>

              <div>
                <label htmlFor="subject" className="block text-sm font-medium text-slate-700 mb-1">Subject</label>
                <input id="subject" name="subject" type="text" required readOnly={isSubmitting} className="w-full rounded-md border border-slate-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white/90" placeholder="Short subject" />
              </div>

              <div>
                <label htmlFor="message" className="block text-sm font-medium text-slate-700 mb-1">Message</label>
                <textarea id="message" name="message" rows={5} required readOnly={isSubmitting} className="w-full rounded-md border border-slate-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white/90" placeholder="Your message..." />
              </div>

              <div className="pt-2">
                <button type="submit" disabled={isSubmitting} className="px-4 py-2 rounded-md bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-60 disabled:cursor-not-allowed">
                  {isSubmitting ? 'Sending…' : 'Send'}
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </Layout>
  )
}

export default Contact
